import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const mezziDi = (veicoli, pid) => {
  const vs = veicoli.filter((v) => v.padroncino_id === pid && v.is_active !== false);
  const ids = new Set(vs.map((v) => v.id));
  const principali = vs.filter((v) => !(ids.has(v.mezzo_principale_id) && v.mezzo_principale_id !== v.id));
  return principali.map((p) => ({
    id: p.id,
    label: [p.targa, ...vs.filter((v) => v.mezzo_principale_id === p.id && v.id !== p.id).map((v) => v.targa)].join(" - "),
    ids: [p.id, ...vs.filter((v) => v.mezzo_principale_id === p.id).map((v) => v.id)],
  }));
};

export const MezzoSelect = ({ m, veicoli, tessMap = {}, onChange, disabled, testId }) => {
  const mezzi = m.padroncino_id ? mezziDi(veicoli, m.padroncino_id) : [];
  if (mezzi.length < 2) return <span className="text-xs text-muted-foreground">{mezzi[0]?.label || "—"}</span>;
  const vid = m.veicolo_id || tessMap[m.tessera_id];
  const cur = vid === "generale" ? "generale" : mezzi.find((x) => x.ids.includes(vid))?.id || "generale";
  return (
    <Select value={cur} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="h-7 text-xs" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="generale">Generale</SelectItem>
        {mezzi.map((x) => <SelectItem key={x.id} value={x.id}>{x.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
